export default "__VITE_ASSET__DzYDofQ8__"